import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { LayoutVerticalComponent } from '../layout/layout-vertical/layout-vertical.component';
import { HomeComponent } from './home/home.component';
import { TitlesComponent } from './titles/titles.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ImageUploadComponent } from './images/image-upload/image-upload.component';
import { DragDropDirective } from '../shared/directives/drag-drop.directive';
import { StockListComponent } from './manage/stocks/stock-list/stock-list.component';
import { StockCreateModalComponent } from './manage/stocks/stock-create-modal/stock-create-modal.component';
import { PurposeListComponent } from './manage/purposes/purpose-list/purpose-list.component';
import { PurposeCreateModalComponent } from './manage/purposes/purpose-create-modal/purpose-create-modal.component';
import { ResolutionCreateModalComponent } from './manage/resolutions/resolution-create-modal/resolution-create-modal.component';
import { ResolutionListComponent } from './manage/resolutions/resolution-list/resolution-list.component';
import { ResolutionAssignListComponent } from './manage/resolutions/resolution-assign-list/resolution-assign-list.component';
import { UserListComponent } from './security/users/user-list/user-list.component';
import { RolListComponent } from './security/roles/rol-list/rol-list.component';
import { RolCreateModalComponent } from './security/roles/rol-create-modal/rol-create-modal.component';
import { UserCreateModalComponent } from './security/users/user-create-modal/user-create-modal.component';
import { TitleDetailComponent } from './titles/title-detail/title-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxGalleryModule } from 'ngx-gallery';
import { ResolutionAsignModalComponent } from './manage/resolutions/resolution-asign-modal/resolution-asign-modal.component';
import { ClientListComponent } from './manage/clients/client-list/client-list.component';
import { ClientCreateModalComponent } from './manage/clients/client-create-modal/client-create-modal.component';
import { ClientShowkeyModalComponent } from './manage/clients/client-showkey-modal/client-showkey-modal.component';
import { AllianceComponent } from './manage/alliance/alliance.component';
import { FileSaverModule } from 'ngx-filesaver';
import { TitleDownloadComponent } from './titles/title-download/title-download.component';

import { AuthenticationGuard } from 'microsoft-adal-angular6';
import { HeaderComponent } from '../layout/components/header/header.component';
import { SidebarComponent } from '../layout/components/sidebar/sidebar.component';
import { FooterComponent } from '../layout/components/footer/footer.component';
import { LoadingImagesComponent } from './manage/loading-images/loading-images.component';
import { ValidateImagesModalComponent } from './manage/loading-images/validate-images-modal/validate-images-modal.component';
import { ScreenGbpComponent } from './manage/screen-gbp/screen-gbp.component';
import { LoadingMoleskinComponent } from './manage/loading-moleskin/loading-moleskin.component';
import { ValidateMoleskinModalComponent } from './manage/loading-moleskin/validate-moleskin-modal/validate-moleskin-modal.component';
import { SearchTitlesComponent } from './manage/search-titles/search-titles.component';
import { BulkLoadComponent } from './manage/bulk-load/bulk-load.component';

const routes = [
  {
    path: '',
    component: LayoutVerticalComponent,
    children: [
      {
        path: '',
        component: TitlesComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'titles',
        component: TitlesComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'titles/title-detail',
        component: TitleDetailComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'manage/stock-list',
        component: StockListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'manage/purpose-list',
        component: PurposeListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'manage/resolution-list',
        component: ResolutionListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'manage/resolution-assign-list',
        component: ResolutionAssignListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'security/rol-list',
        component: RolListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'security/user-list',
        component: UserListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'webapi/client-list',
        component: ClientListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'alliance-list',
        component: AllianceComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'loading-images',
        component: LoadingImagesComponent,
        canActivate: [AuthenticationGuard]
      }, 
      {
        path: 'loading-moleskin',
        component: LoadingMoleskinComponent,
        canActivate: [AuthenticationGuard]
      }, 
      {
        path: 'screen-gbp',
        component: ScreenGbpComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'search-titles',
        component: SearchTitlesComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'app-bulk-load',
        component: BulkLoadComponent,
        canActivate: [AuthenticationGuard]
      }
    ],
  },
];

@NgModule({
  declarations: [
    HomeComponent,
    TitlesComponent,
    ImageUploadComponent,
    DragDropDirective,
    StockListComponent,
    StockCreateModalComponent,
    PurposeListComponent,
    PurposeCreateModalComponent,
    ResolutionCreateModalComponent,
    ResolutionAsignModalComponent,
    ResolutionListComponent,
    ResolutionAssignListComponent,
    UserListComponent,
    RolListComponent,
    RolCreateModalComponent,
    UserCreateModalComponent,
    TitleDetailComponent,
    ClientListComponent,
    ClientCreateModalComponent,
    ClientShowkeyModalComponent,
    AllianceComponent,
    TitleDownloadComponent,
    LayoutVerticalComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    LoadingImagesComponent,
    ValidateImagesModalComponent,
    ScreenGbpComponent,
    LoadingMoleskinComponent,
    ValidateMoleskinModalComponent,
    SearchTitlesComponent,
    BulkLoadComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NgbModule,
    NgxGalleryModule,
    FileSaverModule,
  ],
  entryComponents: [
    ImageUploadComponent,
    StockCreateModalComponent,
    PurposeCreateModalComponent,
    ResolutionCreateModalComponent,
    RolCreateModalComponent,
    UserCreateModalComponent,
    ResolutionAsignModalComponent,
    ClientCreateModalComponent,
    ClientShowkeyModalComponent,
    TitleDownloadComponent,
    ValidateImagesModalComponent,
    ValidateMoleskinModalComponent
  ]
})
export class PagesModule { }
